var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.865 1.135a.375.375 0 0 1 0 .53l-4.1 4.1a.375.375 0 0 1-.53-.53l4.1-4.1a.375.375 0 0 1 .53 0Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.225 1c0-.207.168-.375.375-.375H11c.207 0 .375.168.375.375v2.4a.375.375 0 0 1-.75 0V1.375H8.6A.375.375 0 0 1 8.225 1ZM1.547 1.547C2.215.88 3.213.625 4.5.625h1a.375.375 0 1 1 0 .75h-1c-1.213 0-1.965.245-2.422.703-.458.457-.703 1.209-.703 2.422v3c0 1.213.245 1.965.703 2.422.457.458 1.209.703 2.422.703h3c1.213 0 1.965-.245 2.422-.703.458-.457.703-1.209.703-2.422v-1a.375.375 0 0 1 .75 0v1c0 1.287-.255 2.285-.922 2.953-.668.667-1.666.922-2.953.922h-3c-1.287 0-2.285-.255-2.953-.922C.88 9.785.625 8.787.625 7.5v-3c0-1.287.255-2.285.922-2.953Z",
    fill: "#123862"
  })));
};
export default SvgLink;